export const sxConfig = {
  fieldColor: {
    '& .MuiInputLabel-root': {
      color: '#607d8b',
      fontSize: '0.75rem',
      '&.Mui-focused': {
        color: '#0076f8',
      },
    },
    '& .MuiInputLabel-root.MuiInputLabel-shrink': {
      transform: 'translate(0, 1px) scale(0.9)',
      transformOrigin: 'top left',
    },
    '& .MuiInputBase-root.MuiInput-root': {
      height: '30px',
      fontSize: '0.8125rem',
      lineHeight: 1.2,
    },
    '& .MuiInputBase-input': {
      color: '#334155',
      fontSize: '0.8125rem',
      paddingTop: '2px',
      paddingBottom: '3px',
    },
    '& .MuiAutocomplete-inputRoot.MuiInput-root': {
      paddingTop: '0 !important',
      paddingBottom: '0 !important',
    },
    '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
      paddingTop: '2px !important',
      paddingBottom: '3px !important',
    },
    '& .MuiSelect-select.MuiInputBase-input': {
      minHeight: 'auto',
      paddingTop: '2px',
      paddingBottom: '3px',
    },
    '& .MuiSvgIcon-root': {
      color: '#64748b',
      fontSize: '1rem',
    },
    '& .MuiFormHelperText-root:empty': {
      display: 'none',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#cbd5e1',
    },
  },
};
